<template>
  <v-flex class="back center-style "
          :style=" {background:' linear-gradient(to top, rgba(5, 11, 31, 0.8), rgba(5, 11, 31, 0.8)), url('+ image +')'}">
    <v-flex class="page-name">{{pageName}}</v-flex>
    <v-divider class="blue-divider"></v-divider>
    <v-breadcrumbs :items="items"
                   class="breadcrumbs"
                   divider="/">
      <template slot="item"
                slot-scope="props">
        <router-link :to="{ name: props.item.href }"
                     class="link">{{ props.item.name}}</router-link>
      </template>
    </v-breadcrumbs>
  </v-flex>
</template>

<script>
export default {
  data () {
    return {
      items: [],
      image: require('@/images/background/breadcrumbs3.jpg'),
      pageName: ""
    }
  },

  watch: {
    $route () {
      const vm = this;
      vm.updateBreadcrumbs()
    },
  },

  mounted () {
    const vm = this;
    vm.updateBreadcrumbs()
  },

  methods: {
    updateBreadcrumbs () {
      const vm = this;
      vm.items = vm.$route.meta.breadcrumb;
      vm.pageName = vm.$route.meta.pageName;
    },
  },
}
</script>

<style scoped>
.center-style {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.back {
  height: 300px;
  background-position: center center !important;
}
.breadcrumbs >>> .v-breadcrumbs__divider {
  color: aliceblue;
  font-size: 20px;
}
.breadcrumbs .link {
  text-decoration: none;
  color: gainsboro;
  font: bold 24px Sans-Serif;
  letter-spacing: -1px;
  white-space: nowrap;
  display: inline-block;
  position: relative;
  font-size: 25px;
  font-family: "宋体";
}
.page-name {
  width: 240px;
  flex: none;
  font-size: 60px;
  font-family: "宋体";
  color: gainsboro;
}
.blue-divider {
  width: 30px;
  border: 2px solid #42a5f6 !important;
  margin: 3px 0 20px 0;
}
</style>